// src/hooks/useAccessControl.js
import { useAccessControlState } from "../context/AccessControlContext";
export function useAccessControl() {
  return useAccessControlState();
}
